import { render, staticRenderFns } from "./c-instructions-video.vue?vue&type=template&id=100a2e66&"
import script from "./c-instructions-video.vue?vue&type=script&lang=js&"
export * from "./c-instructions-video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports